import axiosInstance from "../Interceptor";

export const getVendorAddressApi = (data) => {
  //   console.log(data, 'from api');


  return axiosInstance
    .get(`users/api/v1/vendor/profile/${data}/`)
    .then((res) => {
      // console.log(res);
      return res;
    })
    .catch((err) => {
      // console.log(err);
      return err;
    });
};
